'use client';

import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router';

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  showBack?: boolean;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode; 
}

export function PageHeader({ title, subtitle, showBack = false, leftElement, rightElement }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="flex items-center justify-between px-2 mb-6 pt-2">
      <div className="flex items-center gap-4 min-w-0">
        
        {/* Botón de atrás o elemento izquierdo */}
        {leftElement ? (
            <div className="shrink-0">{leftElement}</div>
        ) : showBack && (
          <button 
            onClick={() => navigate(-1)}
            className="h-12 w-12 rounded-[1.2rem] bg-white border border-zinc-100 flex items-center justify-center active:scale-90 active:bg-zinc-50 transition-all shrink-0 shadow-sm"
            aria-label="Volver atrás"
          >
            <ChevronLeft className="h-6 w-6 text-zinc-900" strokeWidth={2.5} />
          </button>
        )}

        {/* Títulos */}
        <div className="flex flex-col min-w-0">
          <h1 className="text-2xl font-black italic uppercase tracking-tighter text-zinc-900 leading-none truncate">
            {title}
          </h1>
          {subtitle && (
            <div className="mt-1">
              {typeof subtitle === 'string' ? (
                <p className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest truncate">
                  {subtitle}
                </p>
              ) : (
                subtitle
              )}
            </div>
          )}
        </div>
      </div>

      {/* Elemento opcional a la derecha */}
      {rightElement && (
        <div className="shrink-0">{rightElement}</div>
      )}
    </header>
  );
}
